import Validatable from '@/validator/Validatable';

interface WorkflowConfiguration {
  name: string;
  id: number;
}

interface IJourneyPostResponseApi {
  workflow_configuration: WorkflowConfiguration;
}

export default class JourneyPostResponse extends Validatable<JourneyPostResponse> {
  constructor(
    public readonly id: number,
    public readonly name: string,
  ) {
    super();
  }

  static fromApi(api: IJourneyPostResponseApi) {
    return new JourneyPostResponse(api.workflow_configuration.id, api.workflow_configuration.name);
  }

  toApi(): IJourneyPostResponseApi {
    return {
      workflow_configuration: { id: this.id, name: this.name },
    };
  }
}
